import { FillLayerSpecification } from "maplibre-gl";
import { ExpressionSpecification } from "@maplibre/maplibre-gl-style-spec";
import type { YieldBucket } from "./apple-count-helper";

export type BucketPaintOptions = {
  property: string;
  colorVar: (bucketIndex: number, bucketCount: number) => string;
  mode: "interpolate" | "step";
  opacity: number;
};

export function buildBucketPaint(
  buckets: YieldBucket[],
  { property, colorVar, mode, opacity }: BucketPaintOptions,
): FillLayerSpecification["paint"] {
  const rootStyle = getComputedStyle(document.documentElement);
  const colorOf = (bucketIndex: number): string =>
    rootStyle.getPropertyValue(colorVar(bucketIndex, buckets.length)).trim();

  // "interpolate" needs at least two stops, and one bucket is a flat fill
  // either way.
  if (buckets.length < 2) {
    return {
      "fill-color": ["to-color", colorOf(0)],
      "fill-opacity": opacity,
    };
  }

  const input: ExpressionSpecification = ["number", ["get", property]];
  const stops = buckets.flatMap((bucket, index) => [
    bucket.min,
    colorOf(index),
  ]);

  const fillColor = (
    mode === "interpolate"
      ? ["interpolate", ["linear"], input, ...stops]
      : ["step", input, colorOf(0), ...stops]
  ) as ExpressionSpecification;

  return {
    "fill-color": fillColor,
    "fill-opacity": opacity,
  };
}
